import { Controller } from "@hotwired/stimulus"
import axios from 'axios';
import React from "react";
import { createRoot } from 'react-dom/client'
import getFriendlyErrorMessage from '../../javascript/helpers/getFriendlyErrorMessage';
import { TabelaLogGeracao } from "../../javascript/components/tabela-log-geracao";

import { hideModalCarregando, showModalCarregando } from "../../javascript/modal-carregando";

export default class extends Controller {
  rootLogs = null;


  async onSubmit(event) {
    event.preventDefault()
    event.stopImmediatePropagation();

    const form = document.getElementById('form-gerar-relatorios');
    const formData = new FormData(form);
  
    try {
      this.hideErrors();
      this.hideLog();
      showModalCarregando('Processando... Por favor aguarde, essa operação pode levar alguns minutos.');
      const { data } = await axios.post(form.action, formData);

      this.showlog(data.log);
    } catch (err) {
      console.error(err);
      const message = getFriendlyErrorMessage(err, "Houve um erro ao processar os dados. Por favor, tente novamente");
      this.showErrors(message);
    } finally {
      hideModalCarregando();
    }
  }

  showlog(log) {
    if(this.rootLogs) {
      this.hideLog();
    }

    const node = document.getElementById('container-logs');
    this.rootLogs = createRoot(node);
    this.rootLogs.render(<TabelaLogGeracao logs={log} />);
  }

  hideLog() {
    if(this.rootLogs) {
      this.rootLogs.unmount();
      this.rootLogs = null;
    }
  }

  showErrors(message) {
    const container = document.getElementById('error-message-container');
    const errorMessage = document.getElementById('error-message');
    errorMessage.innerHTML = message;
    container.style.display = '';
  }

  hideErrors() {
    const container = document.getElementById('error-message-container');
    const errorMessage = document.getElementById('error-message');
    errorMessage.innerHTML = '';
    container.style.display = 'none';
  }
}